
namespace TabAurous.ProductDevelopment {
    import fld = SpecSheetItemsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class SpecSheetItemsDialogForPD extends _Ext.ItemEditorDialog<SpecSheetItemsRow> {
        protected getFormKey() { return SpecSheetItemsForm.formKey; }
        protected getLocalTextPrefix() { return SpecSheetItemsRow.localTextPrefix; }
        protected useViewMode() { return true; }
        public form = new SpecSheetItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 250;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);
            q.HideDialogToolbar(this.element);
            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.Image1);
            q.hideEditorLabel(this.form.Image2);
            q.hideEditorLabel(this.form.Image3);
            q.hideEditorLabel(this.form.Image4);
            q.hideEditorLabel(this.form.Image5);
            q.hideEditorLabel(this.form.Image6);
            q.hideEditorLabel(this.form.Image7);
            q.hideEditorLabel(this.form.Image8);
            q.hideEditorLabel(this.form.Video1);
            q.hideEditorLabel(this.form.Video2);
            q.hideEditorLabel(this.form.LaborDetails);
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);

            // #endregion

        }

        getItem() {
            return this.getSaveEntity();
        }

        removeBOM() {
            var item = [];
            this.form.BOMDetails.view.setItems(item, true);
        }

        // #endregion
        // **** Load Entity event to set fields values ****
        protected afterLoadEntity() {
            super.afterLoadEntity();

            if (this.form.ProductTypeId.value == "") {
                this.form.ProductTypeId.items = this.form.ProductTypeId.items.filter(x => x.id != "5" && x.id != "6" && x.id != "7");
            }

            var c = this.form.CalcOnId.value; 
            q.showAndEnableField(this.form.CalcOnId);
            q.showAndEnableField(this.form.CalcUnitId);
            this.form.CalcOnId.value = c;
            q.showAndEnableField(this.form.RefNo);

        }

    }
}